module.exports = "//cdn.cnbj2m.fds.api.mi-img.com/rdp-outer/qiankun-admin/202409250922110/img/404.3ec06ef5.jpg";